import axios from 'axios';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export const downloadMultiPagePDF = (page_name) => {
  document.getElementById('page_content').classList.add('pdf-styling');
  const page_content = document.getElementById('page_main_content');

  html2canvas(page_content, {
    allowTaint: true,
    useCORS: true,
    logging: true,
    scrollX: 0,
    scrollY: -window.scrollY
  }).then((canvas) => {
    const imgData = canvas.toDataURL('image/jpeg');
    const doc = new jsPDF('p', 'mm', 'a4');

    const pageHeight = doc.internal.pageSize.getHeight();
    const imgProps = doc.getImageProperties(imgData);
    const imgWidth = doc.internal.pageSize.getWidth();
    const imgHeight = (imgProps.height * imgWidth) / imgProps.width;

    let heightLeft = imgHeight;
    let position = 0;
    doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    while (heightLeft >= 0) {
      position = heightLeft - imgHeight;
      doc.addPage();
      doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }
    doc.save(page_name);
  });
  document.getElementById('page_content').classList.remove('pdf-styling');
};

export const getLearnerCompletedCourses = (courses_data) => {
  return courses_data.filter((course) => course.progress_data.course_completed === true);
};

export const getCourseDetailInfo = (courses_data, course_id) => {
  return courses_data.find((course) => course.course_id === course_id);
};

export const getCourseInstructors = (course_data) => {
  let instructors = [];
  course_data.staff.forEach(function(instructor) {
    if (instructor.role === 'instructor') {
      instructors.push(instructor.username);
    }
  });

  return instructors.length > 0 ? instructors.join(', ') : 'N/A';
};

export const fetchDataRecursive = async (url, params) => {
  let requestOptions = {
    method: 'GET',
    withCredentials: true,
    url
  };

  if (params !== undefined) {
    requestOptions['params'] = params;
  }

  const response = await axios(requestOptions);
  const data = response.data.results;
  if (!response.data.next) {
    return response.data.results;
  } else {
    return data.concat(await fetchDataRecursive(response.data.next));
  }
};
